import loglevel, { setLevel } from 'loglevel'

// import { ENV_DEV } from '@/lib/config'

const initLogLevel = () => setLevel('trace')
// const initLogLevel = () => (ENV_DEV ? setLevel('trace') : setLevel('error'))
initLogLevel()

export const log = loglevel
